<template>
  <section
    class="tab-wrap"
    :class="{
      'tab-progress': $slots.bar,
      'tab-sticky-active': isSticky,
      'tab-sticky-header': isHeaderShow,
      'tab-sticky-sub': isSubTab
    }"
    v-bind="$attrs"
  >
    <div class="tab-inner">
      <div class="tab">
        <div class="tab-scroll">
          <router-link
            v-for="(item, key) in tabList"
            :key="key"
            :to="{
              name: item.path,
              params: {
                ...item.params,
                locale: $route.params.locale
              },
              query : {
                ...item.query
              },
              hash: item.hash
            }"
            :active-class="index ? 'active' : 'router-link-active'"
            :class="{
              active: index === key
            }"
            v-on="$listeners"
            @click.native="onClick"
          >
            {{ $t(item.name) }}
          </router-link>
        </div>
        <slot name="bar" />
      </div>
      <slot name="sub" />
    </div>
  </section>
</template>

<script>
import { debounce } from 'lodash'

export default {
  name: 'Tab',
  props: {
    index: {
      type: Number,
      default: 0
    },
    tabList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      isSticky: false,
      isSubTab: true,
      isHeaderShow: false,
      onDebounceHandler: null
    }
  },
  mounted () {
    if (this.$el.classList.contains('tab-sticky')) {
      this.onDebounceHandler = debounce(this.onScroll, 10)
      window.addEventListener('scroll', this.onDebounceHandler)
      this.onScroll()

      this.$root.$on('header-show', (offset) => {
        this.isHeaderShow = offset
      })
    }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onDebounceHandler)
  },
  methods: {
    onScroll () {
      // const isPcHeader = window.matchMedia('(min-width: 1200px)')
      const offsetTop = this.$el.getBoundingClientRect().top
      // const headerHeight = isPcHeader.matches ? 95 : 63
      const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'))

      this.isSticky = offsetTop >= 0 && offsetTop <= headerHeight

      if (this.isHeaderShow && offsetTop < headerHeight) {
        this.$el.querySelector('.tab-inner').style.transform = `translateY(${headerHeight}px)`
        this.isSubTab = false
      } else {
        this.$el.querySelector('.tab-inner').style.transform = 'none'
        this.isSubTab = true
      }
    },
    onClick (e) {
      this.$emit('click:tab', e, this)
    }
  }
}
</script>
